import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPlay,FiClock,FiUsers,FiTrendingUp}=FiIcons;

const Hero=()=> {
  const openVideo=()=> {
    // Open YouTube video in a new tab with proper parameters
    const videoUrl='https://www.youtube.com/watch?v=aDfgGOhDsmc&si=TIOaoO_VOIVd61Ke';
    window.open(videoUrl,'_blank','noopener,noreferrer');
  };

  const navigateToCourse=()=> {
    window.open('https://swiy.co/hYor','_blank','noopener,noreferrer');
  };

  return (
    <section className="pt-32 pb-20 bg-gradient-to-br from-slate-50 to-blue-50 dark:from-slate-900 dark:to-slate-800">
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12 xl:px-16">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{opacity: 0,x: -50}}
            animate={{opacity: 1,x: 0}}
            transition={{duration: 0.8}}
          >
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-slate-800 dark:text-white leading-tight mb-8">
              <span className="block">Master AI in</span>
              <span className="text-amber-500 bg-amber-50 dark:bg-amber-900/30 px-4 py-2 rounded-lg inline-block mt-2">30 Days</span>
              <span className="block mt-2">Minus Tech Stress</span>
            </h1>
            <p className="text-2xl md:text-3xl text-slate-700 dark:text-slate-200 mb-10 leading-relaxed font-medium">
              Practical AI training designed for busy Gen X professionals who want <span className="text-amber-600 dark:text-amber-400 font-bold">real results</span>,not fluff.
            </p>
            <motion.button 
              onClick={navigateToCourse}
              className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white px-12 py-8 rounded-2xl text-3xl font-extrabold transition-all duration-200 hover:scale-105 shadow-2xl mb-10 border-4 border-amber-300"
              whileHover={{scale: 1.02}}
              whileTap={{scale: 0.98}}
            >
              Start Learning Today - <span className="relative inline-block">
                <span className="text-red-600 line-through decoration-red-600 decoration-6 text-2xl ml-3">$250</span>
                <span className="ml-3 font-black bg-gradient-to-r from-green-400 to-emerald-500 bg-clip-text text-transparent drop-shadow-lg" style={{fontSize: '3.5rem',lineHeight: '1'}}>$65</span>
              </span>
            </motion.button>
            <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-4 sm:space-y-0 sm:space-x-8 text-lg text-slate-700 dark:text-slate-300">
              <div className="flex items-center bg-blue-50 dark:bg-blue-900/30 px-4 py-3 rounded-lg">
                <SafeIcon icon={FiUsers} className="w-6 h-6 mr-3 text-blue-600" />
                <span className="font-semibold">By GenX,For Gen X</span>
              </div>
              <div className="flex items-center bg-green-50 dark:bg-green-900/30 px-4 py-3 rounded-lg">
                <SafeIcon icon={FiClock} className="w-6 h-6 mr-3 text-green-600" />
                <span className="font-semibold">Self-Paced</span>
              </div>
              <div className="flex items-center bg-purple-50 dark:bg-purple-900/30 px-4 py-3 rounded-lg">
                <SafeIcon icon={FiTrendingUp} className="w-6 h-6 mr-3 text-purple-600" />
                <span className="font-semibold">Actionable</span>
              </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{opacity: 0,x: 50}}
            animate={{opacity: 1,x: 0}}
            transition={{duration: 0.8,delay: 0.2}}
            className="relative"
          >
            <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl p-8 border-4 border-amber-200 dark:border-amber-600">
              <div className="relative bg-slate-100 dark:bg-slate-700 rounded-xl overflow-hidden group cursor-pointer" onClick={openVideo}>
                <img 
                  src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop&crop=center" 
                  alt="AI Learning Interface" 
                  className="w-full h-72 object-cover transition-transform duration-300 group-hover:scale-105" 
                />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center transition-all duration-300 group-hover:bg-opacity-40">
                  <motion.button 
                    className="bg-white bg-opacity-95 rounded-full p-6 hover:bg-opacity-100 transition-all duration-200 shadow-xl hover:shadow-2xl"
                    whileHover={{scale: 1.1}}
                    whileTap={{scale: 0.9}}
                    onClick={(e)=> {
                      e.stopPropagation();
                      openVideo();
                    }}
                  >
                    <SafeIcon icon={FiPlay} className="w-12 h-12 text-slate-800" />
                  </motion.button>
                </div>
                <div className="absolute bottom-4 left-4 bg-black bg-opacity-80 text-white px-4 py-2 rounded-lg text-lg font-semibold">
                  10 Min - Course Preview
                </div>
                <div className="absolute top-4 right-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold flex items-center">
                  <SafeIcon icon={FiPlay} className="w-4 h-4 mr-2" />
                  WATCH NOW
                </div>
              </div>

              <div className="mt-6">
                <h3 className="font-bold text-2xl text-slate-800 dark:text-white mb-4">What You'll Master</h3>
                <div className="space-y-3 text-lg text-slate-700 dark:text-slate-200">
                  <div className="flex items-center bg-gradient-to-r from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-800/20 p-3 rounded-lg">
                    <div className="w-4 h-4 bg-green-500 rounded-full mr-4"></div>
                    <span className="font-semibold">Generative AI for Daily Productivity</span>
                  </div>
                  <div className="flex items-center bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 p-3 rounded-lg">
                    <div className="w-4 h-4 bg-blue-500 rounded-full mr-4"></div>
                    <span className="font-semibold">Tools for AI Workflow Management</span>
                  </div>
                  <div className="flex items-center bg-gradient-to-r from-purple-50 to-purple-100 dark:from-purple-900/20 dark:to-purple-800/20 p-3 rounded-lg">
                    <div className="w-4 h-4 bg-purple-500 rounded-full mr-4"></div>
                    <span className="font-semibold">Image AI Creation</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;